import {
  ALERTS_CLEAR,
  ASSET_CREATE,
  ASSET_DELETE,
  ASSET_UPDATE,
  ASSET_MODEL_CREATE,
  ASSET_MODEL_READ,
  ASSET_MODEL_UPDATE,
  ASSET_MODEL_DELETE,
  CORE_READ,
  FLEET_CREATE,
  FLEET_DELETE,
  FLEET_REPORTS,
  FLEET_UPDATE,
  GEOFENCE_CREATE,
  GEOFENCE_DELETE,
  GEOFENCE_UPDATE,
  MAINTENANCE_PARTS_CREATE,
  MAINTENANCE_PARTS_DELETE,
  MAINTENANCE_PARTS_UPDATE,
  MAINTENANCE_REMINDERS_CREATE,
  MAINTENANCE_REMINDERS_DELETE,
  MAINTENANCE_REMINDERS_UPDATE,
  MAINTENANCE_SCHEDULES_CREATE,
  MAINTENANCE_SCHEDULES_DELETE,
  MAINTENANCE_SCHEDULES_UPDATE,
  ORGANIZATION_CREATE,
  ORGANIZATION_UPDATE,
  ORGANIZATION_DELETE,
  ORGANIZATION_MOVE,
  OUTPUTSIGNAL_CREATE,
  OUTPUTSIGNAL_DELETE,
  OUTPUTSIGNAL_UPDATE,
  REMOTE_CREATE,
  REMOTE_DELETE,
  REMOTE_EXECUTE,
  REPORT_CREATE,
  REPORT_DELETE,
  REPORT_SCHEDULE,
  REPORT_UPDATE,
  RULE_CONDITIONS_CREATE,
  RULE_CONDITIONS_DELETE,
  RULE_CONDITIONS_UPDATE,
  RULES_CREATE,
  RULES_DELETE,
  RULES_UPDATE,
  SIGNAL_CARDS_UPDATE,
  SIGNAL_COLLECTIONS_CREATE,
  SIGNAL_COLLECTIONS_DELETE,
  SIGNAL_COLLECTIONS_UPDATE,
  TRANSFORMS_CREATE,
  TRANSFORMS_DELETE,
  TRANSFORMS_UPDATE,
  USER_CREATE,
  USER_UPDATE,
  USER_DELETE,
  USER_PERMISSION_CREATE,
  USER_PERMISSION_UPDATE,
  USER_PERMISSION_DELETE,
  USER_PROFILE_CREATE,
  USER_PROFILE_UPDATE,
  USER_PROFILE_DELETE,
  USER_COMMANDS_UPDATE,
  WATERTRANSFER_CREATE,
  WATERTRANSFER_DELETE,
  WATERTRANSFER_UPDATE,
  WIDGET_CREATE,
  WIDGET_DELETE,
  WIDGET_UPDATE,
  WIDGET_GRID_UPDATE,
} from '../Constants/RBAC';

export const ref = {
  accessDefault:
    'Your account does not have the permission required to perform this action',
  accessDropdown:
    'Some of these actions are restricted based on your access level',
  commandsDefault: 'Command and Control is disabled',
  commandsOrg: 'Command and Control is disabled for this organization',
  commandsAsset: 'Command and Control is disabled for this asset',
  commandsAssetModel: 'Command and Control is disabled for this asset model',
  commandsUser: 'Command and Control is disabled for this user',
};

const tips = {
  static: {
    [ALERTS_CLEAR]: ref.accessDefault,
    [ASSET_CREATE]: ref.accessDefault,
    [ASSET_UPDATE]: ref.accessDropdown,
    [ASSET_DELETE]: ref.accessDefault,
    [ASSET_MODEL_CREATE]: ref.accessDefault,
    [ASSET_MODEL_READ]: ref.accessDefault,
    [ASSET_MODEL_UPDATE]: ref.accessDefault,
    [ASSET_MODEL_DELETE]: ref.accessDefault,
    [CORE_READ]: ref.accessDefault,
    [REMOTE_DELETE]: ref.accessDefault,
    [FLEET_CREATE]: ref.accessDefault,
    [FLEET_DELETE]: ref.accessDefault,
    [FLEET_UPDATE]: ref.accessDefault,
    [FLEET_REPORTS]: ref.accessDefault,
    [GEOFENCE_CREATE]: ref.accessDefault,
    [GEOFENCE_UPDATE]: ref.accessDefault,
    [GEOFENCE_DELETE]: ref.accessDefault,
    [MAINTENANCE_PARTS_CREATE]: ref.accessDefault,
    [MAINTENANCE_PARTS_UPDATE]: ref.accessDefault,
    [MAINTENANCE_PARTS_DELETE]: ref.accessDefault,
    [MAINTENANCE_REMINDERS_CREATE]: ref.accessDefault,
    [MAINTENANCE_REMINDERS_UPDATE]: ref.accessDefault,
    [MAINTENANCE_REMINDERS_DELETE]: ref.accessDefault,
    [MAINTENANCE_SCHEDULES_CREATE]: ref.accessDefault,
    [MAINTENANCE_SCHEDULES_UPDATE]: ref.accessDefault,
    [MAINTENANCE_SCHEDULES_DELETE]: ref.accessDefault,
    [ORGANIZATION_CREATE]: ref.accessDefault,
    [ORGANIZATION_UPDATE]: ref.accessDefault,
    [ORGANIZATION_DELETE]: ref.accessDefault,
    [ORGANIZATION_MOVE]: ref.accessDefault,
    [OUTPUTSIGNAL_CREATE]: ref.accessDefault,
    [OUTPUTSIGNAL_DELETE]: ref.accessDefault,
    [OUTPUTSIGNAL_UPDATE]: ref.accessDefault,
    [REPORT_CREATE]: ref.accessDefault,
    [REPORT_DELETE]: ref.accessDefault,
    [REPORT_UPDATE]: ref.accessDefault,
    [REPORT_SCHEDULE]: ref.accessDefault,
    [RULES_CREATE]: ref.accessDefault,
    [RULES_UPDATE]: ref.accessDefault,
    [RULES_DELETE]: ref.accessDefault,
    [RULE_CONDITIONS_CREATE]: ref.accessDefault,
    [RULE_CONDITIONS_UPDATE]: ref.accessDefault,
    [RULE_CONDITIONS_DELETE]: ref.accessDefault,
    [SIGNAL_CARDS_UPDATE]: ref.accessDefault,
    [SIGNAL_COLLECTIONS_CREATE]: ref.accessDefault,
    [SIGNAL_COLLECTIONS_UPDATE]: ref.accessDefault,
    [SIGNAL_COLLECTIONS_DELETE]: ref.accessDefault,
    [TRANSFORMS_CREATE]: ref.accessDefault,
    [TRANSFORMS_UPDATE]: ref.accessDefault,
    [TRANSFORMS_DELETE]: ref.accessDefault,
    [USER_CREATE]: ref.accessDefault,
    [USER_UPDATE]: ref.accessDefault,
    [USER_DELETE]: ref.accessDefault,
    [USER_PERMISSION_CREATE]: ref.accessDefault,
    [USER_PERMISSION_UPDATE]: ref.accessDefault,
    [USER_PERMISSION_DELETE]: ref.accessDefault,
    [USER_PROFILE_CREATE]: ref.accessDefault,
    [USER_PROFILE_UPDATE]: ref.accessDefault,
    [USER_PROFILE_DELETE]: ref.accessDefault,
    [USER_COMMANDS_UPDATE]: ref.accessDefault,
    [WATERTRANSFER_CREATE]: ref.accessDefault,
    [WATERTRANSFER_UPDATE]: ref.accessDefault,
    [WATERTRANSFER_DELETE]: ref.accessDefault,
    [WIDGET_CREATE]: ref.accessDefault,
    [WIDGET_UPDATE]: ref.accessDropdown,
    [WIDGET_DELETE]: ref.accessDefault,
    [WIDGET_GRID_UPDATE]: ref.accessDefault,
  },
  dynamic: {
    [REMOTE_CREATE]: ({ currentOrgRemote, currentUserRemote }) => {
      return !currentOrgRemote
        ? ref.commandsOrg
        : !currentUserRemote
          ? ref.commandsUser
          : ref.commandsAssetModel;
    },
    [REMOTE_EXECUTE]: ({
      assetRemote,
      currentOrgRemote,
      currentUserRemote,
    }) => {
      return !assetRemote
        ? ref.commandsAsset
        : !currentOrgRemote
          ? ref.commandsOrg
          : !currentUserRemote
            ? ref.commandsUser
            : ref.commandsDefault;
    },
  },
};

export default tips;
